import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss']
})
export class AppFooterComponent implements OnInit {

  currentYear: string;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {
    const self = this;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      setTimeout(() => {
        self.dynamicMarginUpdateForFooter();
      }, 1000);
    });
  }

  ngOnInit(): void {
    this.currentYear = '' + new Date().getFullYear();
  }

  dynamicMarginUpdateForFooter() {
    let margin = 0;
    if (this.elRef.nativeElement.parentElement.getElementsByClassName('p-footer-sticky') &&
      this.elRef.nativeElement.parentElement.getElementsByClassName('p-footer-sticky').length > 0) {
      margin = 60;
    }

    this.renderer.setStyle(
      this.elRef.nativeElement,
      'margin-bottom',
      margin + 'px'
    );
  }
}
